<script>
export default {
  name: "vendors_tel",
  props: {
    wastesOrServiceBySchedule: {
      type: Array,
      default: () => []
    },
  },
  computed: {
    tels() {
      let telArray = 
      this.wastesOrServiceBySchedule.map(waste_or_services_by_schedule => {
        return waste_or_services_by_schedule?.waste_or_service_by_work_order.disposal_site?.disposal_site_by_waste_category?.vendor_site_of_treatment?.vendor?.tel;
      }).filter(x => !!x);
      let telSet = new Set(telArray);
      return Array.from(telSet).join('<br>');
    },
  }
}
</script>

<template>
  <div v-if="tels" v-html="tels" class="content-area"></div>
</template>

<style scoped lang="scss">
.content-area {
  padding: 10px;
  background: #f8f9fa;
  width: 100%;
}
</style>
